/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface CallSettings
 */
export interface CallSettings {
  /**
   * field name to get phone number from
   * @type {string}
   * @memberof CallSettings
   */
  phoneField?: CallSettingsPhoneFieldEnum;
}

/**
 * @export
 */
export const CallSettingsPhoneFieldEnum = {
  PrimaryPhone: 'primary_phone',
  SecondaryPhone: 'secondary_phone',
} as const;
export type CallSettingsPhoneFieldEnum =
  (typeof CallSettingsPhoneFieldEnum)[keyof typeof CallSettingsPhoneFieldEnum];

/**
 * Check if a given object implements the CallSettings interface.
 */
export function instanceOfCallSettings(value: object): value is CallSettings {
  return true;
}

export function CallSettingsFromJSON(json: any): CallSettings {
  return CallSettingsFromJSONTyped(json, false);
}

export function CallSettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CallSettings {
  if (json == null) {
    return json;
  }
  return {
    phoneField: json['phone_field'] == null ? undefined : json['phone_field'],
  };
}

export function CallSettingsToJSON(value?: CallSettings | null): any {
  if (value == null) {
    return value;
  }
  return {
    phone_field: value['phoneField'],
  };
}
